import React from 'react';
import { isEmpty, noop, merge, map, size, get } from 'lodash';

// local dependencies
import { cagFilter as CagFilterView } from './cagFilter.view';
import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';
import { CagFilterService } from 'services/cagFilter';
import { SERVICE_RESPONSE_STATUS, SIZES } from 'constants/common';
import * as errorOverlay from 'utils/errorOverlay';
import * as pageLevelPreloader from 'modules/page-level-preloader';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { CagFilter } from 'modules/cagFilter';
 *
 * // render
 * <ChoiceList propName='propValue'/>
 */
export class CagFilter extends React.Component {
    constructor( props ) {
        super( props );

        // bind methods
        this.handleButtonClick = this.handleButtonClick.bind( this );
        this.openFilterOverlay = this.openFilterOverlay.bind( this );
        this.handleApply = this.handleApply.bind( this );

        // component state
        this.state = {
            value: null,
        };

        // create service instance
        this.cagFilterService = new CagFilterService();
    }
    
    /***************************************/

    /**
     * @desc When filter trigger button is clicked
     */
    async handleButtonClick() {
        log.debug( 'CagFilter.handleButtonClick()' );

        // cancel ongoing request
        this.cagFilterService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        let carrier = [];

        if( 0 !== size( get( this.state, 'value' ) ) ) {

            carrier = map( get( this.state, 'value' ), caginfo => {
                return caginfo.value;
            } );
            
        }

        // get status and service data
        const { status, data } = await this.cagFilterService.fetchFiltersData( {
            url: this.props.filter.url,
            data: merge( this.props.requestPayload, {
                context: {},
                data: {
                    carrier,
                }
            } ),
        } );

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            this.openFilterOverlay( data );
        }  else {
            
            // show error dialog
			if ( ! isEmpty( data.description ) ) {
				errorOverlay.open( { message: data.description, size: SIZES.SMALL } );
			} else {
				errorOverlay.open();
			}
        }
    }

    /**
     * @desc When open button is clicked
     */
    openFilterOverlay( data = {} ) {
        log.debug( 'CagFilter.openFilterOverlay()' );

        overlay.open( {
            settings: {
                modalType: OVERLAY_VIEWS.CAG_FILTER,
                showCloseButton: false,
                ignoreOutsideClick: false,
            },
            config: {},
            data: {
                value: this.state.value,
                carriers: get( data, 'carriers', [] ),
                steps: data.steps,
                actions: data.actions,
                onApply: this.handleApply,
            },
        } );
    }

    /**
     * @desc When `apply` button is clicked.
     */
    handleApply( { values } = {} ) {
        log.debug( 'CagFilter.handleApply()' );

        this.setState( {
            value: values,
        }, () => {
            this.props.onChange( values );
        } );
    }

    /***************************************/

    /**
     * @desc Render view.
     */
    render() {
        return (
            <CagFilterView
                className={ this.props.className }
                displayValue={ this.props.displayValue }
                filter={ this.props.filter }
                onButtonClick={ this.handleButtonClick }
            />
        );
    }
}

// set display name
CagFilter.displayName = 'CagFilter';

// set default props
CagFilter.defaultProps = {
    onChange: noop,
    className: null,
    value: null,
    displayValue: null,
    filter: {},
    requestPayload: {},
};

// prop types
CagFilter.propTypes = {};
